var map = {
	"./01_rooms-deluxe-room.1024.jpg": 3600,
	"./01_rooms-deluxe-room.1024.webp": 302,
	"./01_rooms-deluxe-room.1280.jpg": 9012,
	"./01_rooms-deluxe-room.1280.webp": 9494,
	"./01_rooms-deluxe-room.1536.jpg": 4652,
	"./01_rooms-deluxe-room.1536.webp": 7822,
	"./01_rooms-deluxe-room.640.jpg": 4187,
	"./01_rooms-deluxe-room.640.webp": 953,
	"./01_rooms-deluxe-room.768.jpg": 8628,
	"./01_rooms-deluxe-room.768.webp": 7568,
	"./01_rooms-deluxe-room.original.jpg": 4156,
	"./01_rooms-deluxe-room.original.webp": 4374,
	"./01_rooms-deluxe-room.thumbnail.jpg": 7733,
	"./01_rooms-deluxe-room.thumbnail.webp": 4895,
	"./02_rooms-deluxe-bed.1024.jpg": 9645,
	"./02_rooms-deluxe-bed.1024.webp": 5471,
	"./02_rooms-deluxe-bed.1280.jpg": 3429,
	"./02_rooms-deluxe-bed.1280.webp": 5027,
	"./02_rooms-deluxe-bed.1536.jpg": 5021,
	"./02_rooms-deluxe-bed.1536.webp": 9911,
	"./02_rooms-deluxe-bed.640.jpg": 9792,
	"./02_rooms-deluxe-bed.640.webp": 2970,
	"./02_rooms-deluxe-bed.768.jpg": 5843,
	"./02_rooms-deluxe-bed.768.webp": 7195,
	"./02_rooms-deluxe-bed.original.jpg": 3378,
	"./02_rooms-deluxe-bed.original.webp": 6855,
	"./02_rooms-deluxe-bed.thumbnail.jpg": 8914,
	"./02_rooms-deluxe-bed.thumbnail.webp": 8948,
	"./03_rooms-deluxe-wardrobe.1024.png": 741,
	"./03_rooms-deluxe-wardrobe.1024.webp": 8561,
	"./03_rooms-deluxe-wardrobe.1280.png": 3085,
	"./03_rooms-deluxe-wardrobe.1280.webp": 9637,
	"./03_rooms-deluxe-wardrobe.1536.png": 6325,
	"./03_rooms-deluxe-wardrobe.1536.webp": 2109,
	"./03_rooms-deluxe-wardrobe.640.png": 3804,
	"./03_rooms-deluxe-wardrobe.640.webp": 4848,
	"./03_rooms-deluxe-wardrobe.768.png": 4755,
	"./03_rooms-deluxe-wardrobe.768.webp": 7701,
	"./03_rooms-deluxe-wardrobe.original.png": 3725,
	"./03_rooms-deluxe-wardrobe.original.webp": 9949,
	"./03_rooms-deluxe-wardrobe.thumbnail.png": 6846,
	"./03_rooms-deluxe-wardrobe.thumbnail.webp": 8430,
	"./04_rooms-deluxe-sofas.1024.jpg": 2296,
	"./04_rooms-deluxe-sofas.1024.webp": 2116,
	"./04_rooms-deluxe-sofas.1280.jpg": 2652,
	"./04_rooms-deluxe-sofas.1280.webp": 5428,
	"./04_rooms-deluxe-sofas.1536.jpg": 4228,
	"./04_rooms-deluxe-sofas.1536.webp": 528,
	"./04_rooms-deluxe-sofas.640.jpg": 3043,
	"./04_rooms-deluxe-sofas.640.webp": 4435,
	"./04_rooms-deluxe-sofas.768.jpg": 9084,
	"./04_rooms-deluxe-sofas.768.webp": 9446,
	"./04_rooms-deluxe-sofas.original.jpg": 3380,
	"./04_rooms-deluxe-sofas.original.webp": 752,
	"./04_rooms-deluxe-sofas.thumbnail.jpg": 1901,
	"./04_rooms-deluxe-sofas.thumbnail.webp": 8197,
	"./05_rooms-deluxe-amenities.1024.jpg": 6786,
	"./05_rooms-deluxe-amenities.1024.webp": 6806,
	"./05_rooms-deluxe-amenities.1280.jpg": 8086,
	"./05_rooms-deluxe-amenities.1280.webp": 3502,
	"./05_rooms-deluxe-amenities.1536.jpg": 8730,
	"./05_rooms-deluxe-amenities.1536.webp": 502,
	"./05_rooms-deluxe-amenities.640.jpg": 4713,
	"./05_rooms-deluxe-amenities.640.webp": 4145,
	"./05_rooms-deluxe-amenities.768.jpg": 6798,
	"./05_rooms-deluxe-amenities.768.webp": 7496,
	"./05_rooms-deluxe-amenities.original.jpg": 1226,
	"./05_rooms-deluxe-amenities.original.webp": 8814,
	"./05_rooms-deluxe-amenities.thumbnail.jpg": 6839,
	"./05_rooms-deluxe-amenities.thumbnail.webp": 967,
	"./06_rooms-deluxe-amenities2.1024.png": 8405,
	"./06_rooms-deluxe-amenities2.1024.webp": 4853,
	"./06_rooms-deluxe-amenities2.1280.png": 5181,
	"./06_rooms-deluxe-amenities2.1280.webp": 7889,
	"./06_rooms-deluxe-amenities2.1536.png": 4181,
	"./06_rooms-deluxe-amenities2.1536.webp": 4217,
	"./06_rooms-deluxe-amenities2.640.png": 5196,
	"./06_rooms-deluxe-amenities2.640.webp": 6404,
	"./06_rooms-deluxe-amenities2.768.png": 1795,
	"./06_rooms-deluxe-amenities2.768.webp": 6969,
	"./06_rooms-deluxe-amenities2.original.png": 4461,
	"./06_rooms-deluxe-amenities2.original.webp": 7945,
	"./06_rooms-deluxe-amenities2.thumbnail.png": 4398,
	"./06_rooms-deluxe-amenities2.thumbnail.webp": 4954,
	"./07_rooms-deluxe-shelves.1024.jpg": 9067,
	"./07_rooms-deluxe-shelves.1024.webp": 1077,
	"./07_rooms-deluxe-shelves.1280.jpg": 5859,
	"./07_rooms-deluxe-shelves.1280.webp": 2209,
	"./07_rooms-deluxe-shelves.1536.jpg": 847,
	"./07_rooms-deluxe-shelves.1536.webp": 1913,
	"./07_rooms-deluxe-shelves.640.jpg": 2858,
	"./07_rooms-deluxe-shelves.640.webp": 2932,
	"./07_rooms-deluxe-shelves.768.jpg": 5945,
	"./07_rooms-deluxe-shelves.768.webp": 4537,
	"./07_rooms-deluxe-shelves.original.jpg": 9855,
	"./07_rooms-deluxe-shelves.original.webp": 5417,
	"./07_rooms-deluxe-shelves.thumbnail.jpg": 4392,
	"./07_rooms-deluxe-shelves.thumbnail.webp": 7210,
	"./08_rooms-deluxe-bathroom.1024.png": 8102,
	"./08_rooms-deluxe-bathroom.1024.webp": 4308,
	"./08_rooms-deluxe-bathroom.1280.png": 1698,
	"./08_rooms-deluxe-bathroom.1280.webp": 4084,
	"./08_rooms-deluxe-bathroom.1536.png": 7214,
	"./08_rooms-deluxe-bathroom.1536.webp": 4448,
	"./08_rooms-deluxe-bathroom.640.png": 5025,
	"./08_rooms-deluxe-bathroom.640.webp": 2227,
	"./08_rooms-deluxe-bathroom.768.png": 9466,
	"./08_rooms-deluxe-bathroom.768.webp": 1286,
	"./08_rooms-deluxe-bathroom.original.png": 2494,
	"./08_rooms-deluxe-bathroom.original.webp": 7936,
	"./08_rooms-deluxe-bathroom.thumbnail.png": 6599,
	"./08_rooms-deluxe-bathroom.thumbnail.webp": 2373,
	"./09_rooms-deluxe-sink.1024.png": 6708,
	"./09_rooms-deluxe-sink.1024.webp": 518,
	"./09_rooms-deluxe-sink.1280.png": 3168,
	"./09_rooms-deluxe-sink.1280.webp": 2398,
	"./09_rooms-deluxe-sink.1536.png": 9336,
	"./09_rooms-deluxe-sink.1536.webp": 9030,
	"./09_rooms-deluxe-sink.640.png": 7715,
	"./09_rooms-deluxe-sink.640.webp": 177,
	"./09_rooms-deluxe-sink.768.png": 4720,
	"./09_rooms-deluxe-sink.768.webp": 2200,
	"./09_rooms-deluxe-sink.original.png": 344,
	"./09_rooms-deluxe-sink.original.webp": 1121,
	"./09_rooms-deluxe-sink.thumbnail.png": 1557,
	"./09_rooms-deluxe-sink.thumbnail.webp": 3927,
	"./10_rooms-deluxe-room-full.mp4": 9402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1974;